import ApplicationSerializer from './application';

export default ApplicationSerializer.extend({
  keyForModel() {
    return 'transactions';
  },

  include(request) {
    return request.method === 'GET' ? ['accountEntries'] : [];
  },

  serialize(_, request) {
    let json = ApplicationSerializer.prototype.serialize.apply(this, arguments);

    if (json.transactions && request.method === 'GET') {
      json.accounts = this.getRelatedAccounts(json.transactions);
    }

    if (json.accounts) {
      json.accounts.forEach(account => delete account.account_entry_ids);
    }

    json['account_entries'] = json['bookkeeping_account_entries'];
    delete json['bookkeeping_account_entries'];

    return json;
  },

  getRelatedAccounts(transactions) {
    let { schema } = this.registry;

    // ...new Set remove duplicate
    return this.serialize(
      schema.bookkeepingAccounts.find([
        ...new Set(
          transactions.reduce(
            (acc, transaction) => [
              ...acc,
              ...schema
                .collectionForType('bookkeeping-account-entry')
                .where({ transactionId: transaction.id })
                .map(accountEntry => accountEntry.accountId),
            ],
            []
          )
        ),
      ])
    ).accounts;
  },
});
